// import request from 'superagent'

/* function getFormData(postData)
{
    const formData = new FormData()

    for (const key in postData)
    {
        if (Object.prototype.hasOwnProperty.call(postData, key))
        {
            formData.append(key, postData[key])
        }
    }

    return formData
} */

function getFinalUrl(url, getData)
{
    const urlArr = url.split('?')
    const inlineGet = urlArr.length > 1 ? urlArr[1].split('&') : []

    for (const key in getData)
    {
        if (Object.prototype.hasOwnProperty.call(getData, key))
        {
            inlineGet.push(encodeURIComponent(key) + '=' + encodeURIComponent(getData[key]))
        }
    }

    return urlArr[0] + (inlineGet.length > 0 ? ('?' + inlineGet.join('&')) : '')
}

function getInlinePost(postData)
{
    const inlinePost = []

    for (const key in postData)
    {
        if (Object.prototype.hasOwnProperty.call(postData, key))
        {
            inlinePost.push(encodeURIComponent(key) + '=' + encodeURIComponent(postData[key]))
        }
    }

    return inlinePost.join('&')
}

function synchReq(url, onSuccess, onError, getData, {async = true}, postData = null)
{
    const req = new XMLHttpRequest()
    const hasPost = postData ? Object.keys(postData).length > 0 : false
    const finalUrl = getFinalUrl(url, getData)
    // const timeStr = 'API ping ' + finalUrl + (async ? ' (async)' : ' (sync)')
    // console.time(timeStr)

    const callback = () =>
    {
        if (!async || req.readyState === XMLHttpRequest.DONE)
        {
            // console.timeEnd(timeStr)

            if (req.status === 200)
            {
                try
                {
                    onSuccess(JSON.parse(req.responseText), req.status)
                }
                catch (error)
                {
                    onError('Can not load the API data: ' + req.responseURL, req.status)
                }
            }
            else
            {
                onError(req.statusText, req.status)
            }
        }
    }

    if (async)
    {
        req.onreadystatechange = callback
    }

    req.open(hasPost ? 'POST' : 'GET', finalUrl, async)
    if (hasPost)
    {
        req.setRequestHeader('Content-type', 'application/x-www-form-urlencoded')
        req.send(getInlinePost(postData))
    }
    else
    {
        req.send(null)
    }

    if (!async)
    {
        callback()
    }
}

let REQ_NUM = 0


export default class Gateway
{
    constructor()
    {
        if (Gateway._instance)
        {
            return Gateway._instance
        }

        Gateway._instance = this
    }

    static getInstance()
    {
        if (!Gateway._instance)
        {
            Gateway._instance = new Gateway()
        }

        return Gateway._instance
    }

    /* eslint-disable class-methods-use-this */
    send(url, onSuccess, onError, getData = {}, postData = {})
    {
        synchReq(url, onSuccess, onError, getData, {async: ++REQ_NUM > 2}, postData)
    }
}



// WEBPACK FOOTER //
// ./src/scripts/utils/global/Gateway.js